import host from './host.js';
import request from '@/utils/request.js';
import qs from 'qs';

const aboutour = {
	aboutourType() {//获取关于我们分类树
		return request.post(host.test+'/Kitchen/Category/CfwCategoryTree');
	},
}

export default aboutour;